import { useSearchParams } from "react-router-dom"
import { Button, Card, CardContent } from "@mui/material"
import "./style.scss"

function isDatasetError(searchParams) {
  return searchParams.get("risk-model") != null
}

function logout() {
  window.location = "/logout"
}

export default function ContactAdmin() {
  const [searchParams] = useSearchParams()

  return <div className="modules_contact-admin">
    <Card className="content-wrapper">
      <CardContent className="contact-admin">
        <div className="title">Contact your admin</div>
        <div className="text">
          {isDatasetError(searchParams)
            ? "It seems you do not have access to any risk model. Please contact the administrator for your account to request access."
            : "It seems this login has not been fully configured. Please contact the administrator for your account to request access."}
        </div>
        <Button color="primary" variant="contained" size="large" onClick={logout}>
          Logout
        </Button>
      </CardContent>
    </Card>
  </div>
}
